<template>
  <layout-main-inner title="会员详情">
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">基本信息</template>
      <div class="user-logo">
        <div class="logo-img-wrap">
          <img
            class="logo-img"
            :src="customer.headPicture || logo" />
          <img
            v-if="customer.levelIcon"
            :src="customer.levelIcon"
            class="level-icon">
        </div>
        <div class="ent-name">
          {{ customer.userName || '未知' }} <el-tag
            v-if="customer.agentFlag === 1"
            type="success">合伙人</el-tag>
        </div>
      </div>
      <el-form
        label-width="50%"
        class="margin-botton-0">
        <el-row
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="手机号：">{{ customer.mobilePhone }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="生日：">{{ customer.birthday | dateformat('YYYY-MM-DD') }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="性别：">{{ customer.gender | genderFormat() }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="可用积分：">
              <link-route
                v-if="customer.availablePoints"
                @click.native="integral(customer)">
                {{ customer.availablePoints }}
              </link-route>
              <span v-else>0</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="会员等级：">{{ customer.userLevelName }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="所在城市：">{{ customer.country || '未知' }}-{{ customer.province || '未知' }}-{{ customer.city || '未知' }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          type="flex"
          justify="center">
          <el-col :span="12">
            <el-form-item label="最近登录：">{{ customer.lastLoginTime | dateformat() }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </layout-card-wrap>
    <layout-card-wrap
      hasHeaderSlot
      style="margin-top:15px">
      <template slot="title">收货地址</template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="联系人"
          width="120"
          prop="deliveryName"></el-table-column>
        <el-table-column
          label="手机号"
          width="150"
          prop="deliveryPhone"> </el-table-column>
        <el-table-column label="所在地区">
          <template slot-scope="{row}">
            {{ row.provinceName || '未知' }}-{{ row.cityName || '未知' }}-{{ row.areaName || '未知' }}
          </template>
        </el-table-column>
        <el-table-column
          label="详细地址"
          prop="detailedAddress"> </el-table-column>
      </el-table>
    </layout-card-wrap>
    <template slot="footer">
      <button-back />
      <member-integral-modal ref="modal" />
    </template>
  </layout-main-inner>
</template>
<script type="text/ecmascript-6">
import MemberIntegralModal from './busi/member-integral-modal.vue'
const logo = require('../../../assets/images/toux.png')
export default {
  name: 'MemberInfoDetail',
  components: { MemberIntegralModal },
  filters: {
    genderFormat(value) {
      const status = {
        0: '未知',
        1: '男',
        2: '女'
      }
      return status[value]
    }
  },
  data() {
    return {
      logo,
      loading: true,
      customer: {},
      list: []
    }
  },
  mounted() {
    this.getuser()
    this.getdeliveryaddresses()
  },
  methods: {
    integral(customer) {
      this.$refs.modal.fetch(customer.vendorId, customer.userId, customer)
    },
    getuser() {
      this.loading = true
      this.$store.dispatch('member/getuser', {
        payload: this.$route.query,
        success: res => {
          this.loading = false
          this.customer = res.data
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getdeliveryaddresses() {
      this.loading = true
      this.$store.dispatch('member/getdeliveryaddresses', {
        payload: {
          ...this.$route.query,
          pageSize: 1000,
          pageNum: 1
        },
        success: res => {
          this.loading = false
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang='stylus' scoped>
.user-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  .logo-img-wrap {
    position: relative;

    .logo-img {
      width: 128px;
      height: 128px;
      border-radius: 50%;
    }

    .level-icon {
      position: absolute;
      width: 30px;
      height: 30px;
      right: 0;
      bottom: 0;
    }
  }

  .ent-name {
    margin-top: 10px;
    font-size: 20px;
    color: #606266;
  }
}
</style>
